import { WebPlugin } from "@capacitor/core";
export class NavigationBarInfoWeb extends WebPlugin {
    async getNavigationBarInfo() {
        // Return default values for web/iOS platforms
        // Navigation bar is an Android-specific concept
        return {
            heightInDp: 0,
            deviceHeight: 0,
            density: 1,
            isNavigationBarVisible: false,
            isGestureNavigation: false,
        };
    }
}
//# sourceMappingURL=web.js.map